import { redrawPolylines } from './handlePolylines';

export default function handleEvents() {
  // this == React Map component
  const { map, addToHistory } = this;

  map.data.addListener('click', event => {
    if (this.props.deletePolygonMode) {
      const type = event.feature.getGeometry().getType();
      // allow deleting only polygons
      if (type !== 'Polygon') return;

      // eslint-disable-next-line no-alert
      if (window.confirm('Sure?')) {
        map.data.remove(event.feature);
        addToHistory().then(() => redrawPolylines.call(this));
      }
    }
  });

  map.data.addListener('setgeometry', () => {
    if (this.props.editPolygonMode) {
      addToHistory().then(() => redrawPolylines.call(this));
    }
  });

  map.data.addListener('mouseup', () => {
    if (this.props.dragPolygonMode) {
      addToHistory().then(() => redrawPolylines.call(this));
    }
  });
}



// WEBPACK FOOTER //
// ../ui-components/components/CoverageAreaMap/components/Map/methods/handleEvents.js